export const READ_DATASET_EVALUATOR_DEFINITION_TOOL_NAME =
  "read_dataset_evaluator_definition";

/** Hard cap on requested ids, kept in agreement with the server PARAMETERS schema. */
export const MAX_EVALUATOR_IDS = 5;
